export default __webpack_public_path__ + "static/image-2021-12-21-10-15-21-317-20ba5eaa7245341a08df300b43bfc21d.png";